import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { COMMUNITY_DEFAULT_AVATAR, DataTestDirective } from '@outlaw/core';
import { CommunityItem, PostTypes } from '../../../../interfaces';

@Component({
  selector: 'app-post-avatar',
  templateUrl: './post-avatar.component.html',
  styleUrls: ['./post-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataTestDirective],
})
export class PostAvatarComponent {
  item = input.required<CommunityItem>();

  avatarUrl = computed(() => this.getAvatar(this.item().user?.avatar_url));

  repostAvatarUrl = computed(() =>
    this.getAvatar(this.item().content?.community_repost?.source?.source_user?.avatar_url)
  );

  shouldShowRepostedAuthor = computed(() => this.item().post_type.slug === PostTypes.repost);

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = COMMUNITY_DEFAULT_AVATAR;
  }

  private getAvatar(url: string | null | undefined): string {
    return url || COMMUNITY_DEFAULT_AVATAR;
  }
}
